<template>
  <div class="mega-nav-content">
    <component
      :is="getLinkComponent()"
      v-if="hasBaseImage"
      :href="url"
      class="mega-nav-content__image"
    >
      <responsive-image
        v-if="hasBaseImage"
        :class="hasArabicImage && 'show-en'"
        :image="image"
        ratio="1:1"
        sizes="200px"
      />

      <responsive-image
        v-if="hasArabicImage"
        class="show-ar"
        :image="imageArabic"
        ratio="1:1"
        sizes="200px"
      />
    </component>

    <div class="mega-nav-content__body">
      <h5
        v-if="title"
        class="mega-nav-content__title text-heading-m"
        v-text="title"
      />

      <p
        v-if="subtitle"
        class="mega-nav-content__subtitle text-body-s"
        v-text="subtitle"
      />

      <component
        :is="getLinkComponent('span')"
        :href="url"
        class="mega-nav-content__button text-body-slink"
        v-text="button"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Mega nav content (mega-nav-content)
 * -----------------------------------------------------------------------------
 * A content block with image and link support.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'MegaNavContent',

  components: {
    ResponsiveImage,
  },

  props: {
    tierTitle: {
      type: String,
      default: '',
    },

    image: {
      type: Object,
      default: () => ({}),
    },

    imageArabic: {
      type: Object,
      default: () => ({}),
    },

    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },

    button: {
      type: String,
      default: '',
    },

    url: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasBaseImage() {
      return this.image && this.image.src
    },

    hasArabicImage() {
      return this.imageArabic && this.imageArabic.src
    },
  },

  methods: {

    /**
     * Returns the component for a link element.
     * @param {String} fallback - The element to use if no link exists.
     * @returns {String}
     */
    getLinkComponent(fallback = 'div') {
      if (!this.url) {
        return fallback
      }

      return 'a'
    },
  },
}
</script>

<style lang="scss">
@import './mega-nav-content';
</style>
